<template>
	<div class="icd-list">
		<template v-if="list.length === 0">
			<p v-if="context == 'test-results'" class="font-weight-thin ml-2 text-body-2 grey--text" v-translate>No results.</p>
			<p v-else class="font-weight-thin ml-2 text-body-2 grey--text" v-translate>No ICD selected.</p>
		</template>
		<v-list flat>
			<div
				v-infinite-scroll="loadMore"
				infinite-scroll-disabled="loading"
				infinite-scroll-distance="0"
				v-if="infiniteScroll">
				<template v-if="!other">
					<ICDItem
						v-for="icdSymptom in icdListSorted"
						:icdSymptom="icdSymptom"
						:key="icdSymptom.code"
						@remove-icd="removeICD"
						:editable="editable"
						:context="context"
						:patient="patient"
						@open-send-monitoring-email="$emit('open-send-monitoring-email')"
						:showIntensity="showIntensity"
						:disabled="disabled"
						:isExtension="extension"
					/>
				</template>
				<template v-else>
					<ICDOtherItem v-for="item in list" :item="item" :key="item.id" :exclusion="exclusion" :context="context" />
				</template>
				<v-row class="mt-2" v-if="loading" no-gutters>
					<v-progress-linear
            :active="loading"
            :indeterminate="loading"
            top
            color="primary"
          ></v-progress-linear>
				</v-row>
			</div>
			<ICDItem
				v-else
				v-for="icdSymptom in icdListSorted"
				:icdSymptom="icdSymptom"
				:key="icdSymptom.code"
				@remove-icd="removeICD"
				:editable="editable"
				:context="context"
				:patient="patient"
				@open-send-monitoring-email="$emit('open-send-monitoring-email')"
				:showIntensity="showIntensity"
				:disabled="disabled"
				:isExtension="extension"
			/>
		</v-list>
	</div>
</template>

<script>
import ICDItem from "@/components/icd/ICDItem.vue";
import ICDOtherItem from "@/components/icd/ICDOtherItem.vue";
import infiniteScroll from "vue-infinite-scroll";

export default {
	name: "ICDList",
	components: {
		ICDItem,
		ICDOtherItem
	},
	directives: {
		infiniteScroll
	},
	props: {
		list: {},
		editable: { default: true },
		context: {
			default: "appointment"
		},
		patient: {
			default: () => ({})
		},
		showIntensity: {
			default: false
		},
		disabled: {
			default: false
		},
		infiniteScroll: {
			default: false
		},
		extension: {
			default: false
		},
		other: {
			default: false
		},
		exclusion: {
			default: false
		}
	},
	data: () => ({
		loading: false,
		over : false
	}),
	computed: {
		icdListSorted() {
			let newList = this.list;
			return newList.sort((a, b) => {
				return ('' + a.code).localeCompare(b.code);
			})
		}
	},
	methods: {
		loadMore() {
			if(!this.over) {
				this.loading = true;
				console.log("load more");
				this.$emit('load-more');
			}
		},
		addICD(icds) {
			this.loading = false;
			if(icds.length == 0) this.over = true;
			for(let i = 0; i < icds.length; i++) {
        this.list.push(icds[i]);
			}
		},
		removeICD(icd) {
			//CALL API
			//this.list.splice(this.list.indexOf(icd), 1);
			this.$emit("remove-icd", icd);
		}
	}
};
</script>